import { useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { Checkbox } from 'common-components'
import { useDispatch } from 'react-redux'
import { setAppValue } from 'e-submission/apps/actions'
import { FormFeedback } from 'reactstrap'
import { CREDIT_CARD_PAYMENT_METHOD } from 'e-submission/domain/data-model/constants'

const METHOD = CREDIT_CARD_PAYMENT_METHOD

const Header = styled.label`
  font-weight: bold;
`

const Container = styled.div`
  margin-top: 20px;
`

const CreditCardPaymentMethod = ({
  creditCardMethod = '',
  isSendLink = false,
  isRemoteSelling = false,
  handleCheckMethod,
}) => {
  const dispatch = useDispatch()

  const handleChangeCreditCardMethod = useCallback(
    (val) => {
      dispatch(setAppValue('creditCardMethod', val))
      handleCheckMethod(true)
    },
    [dispatch, handleCheckMethod]
  )
  console.log(`creditCardMethod :`, creditCardMethod)
  const isOnAZ = creditCardMethod === METHOD.ON_AZ
  const isQuickLink = creditCardMethod === METHOD.QUICKLINK

  const isMobileApp = !_.isEmpty(window.cordova)

  useEffect(() => {
    if (!isQuickLink && (false || isRemoteSelling)) {
      handleChangeCreditCardMethod(METHOD.QUICKLINK)
    }
  }, [isQuickLink, isMobileApp, isRemoteSelling, handleChangeCreditCardMethod])


  useEffect(() => {
    handleChangeCreditCardMethod(METHOD.QUICKLINK)
  }, [])

  return (
    <div data-testid="creditcard-payment-method">
      {!isRemoteSelling && (
        <div>
          {isMobileApp ? (
            <>
              <Container>
                <Header>รูปแบบการชำระเงิน</Header>
              </Container>
              <Container>
                {!isSendLink ? (
                  <Checkbox checked={isOnAZ} onChange={() => handleChangeCreditCardMethod(METHOD.ON_AZ)}>
                    ชำระทันที
                  </Checkbox>
                ) : isSendLink && isOnAZ ? (
                  <p>ชำระทันที</p>
                ) : null}
              </Container>
              <Container>
                {!isSendLink ? (
                  <Checkbox checked={isQuickLink} onChange={() => handleChangeCreditCardMethod(METHOD.QUICKLINK)}>
                    ผู้เอาประกันชำระผ่านลิงก์ด้วยตนเอง
                  </Checkbox>
                ) : isSendLink && isQuickLink ? (
                  <p>ผู้เอาประกันชำระผ่านลิงก์ด้วยตนเอง</p>
                ) : null}
              </Container>
            </>
          ) : (
            <Container>
              <Header>ผู้เอาประกันชำระผ่านลิงก์ด้วยตนเอง (QuickPay)</Header>
            </Container>
          )}
          <Container>
            <FormFeedback className="info-message attached-icon">
              <p>
                กรณีผู้เอาประกันเลือกชำระผ่านลิงก์ด้วยตนเอง ผ่านบัตรเครดิต KTC สามารถใช้สิทธิ์ผ่อนชำระเบี้ยประกันได้
                ทั้งนี้เป็นไปตามเงื่อนไขของทางบริษัทฯ
              </p>
            </FormFeedback>
          </Container>
        </div>
      )}
    </div>
  )
}

export default CreditCardPaymentMethod
